import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'specialCharPipe'
})
export class removeCharPipe implements PipeTransform {
    transform(value: string): string {
        return value ? value.replace(/-/g, " ") : value;
    }
}